import React, { useState } from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import SaveIcon from "@mui/icons-material/Save";
import { Button } from "@mui/material";
import { Constants, ButtonType } from "../Content";
import { VisuallyHiddenInput } from "../ManageDataTab/ManageDataStyled";
const SearchBoxSection = ({
  isPricingTab,
  handleDownloadTemplate,
  handleUpload,
  data,
  headers,
  handleDownloadData,
  handleProductUpdate,
}) => {
  return (
    <>
      <div className="buttondiv">
        <Button
          component="label"
          className="uploadedFileName"
          variant="outlined"
          size="medium"
          startIcon={<FileDownloadOutlinedIcon />}
          onClick={(e) => handleDownloadData(e, data, headers)}
        >
          {Constants.DOWNLOADDATA}
        </Button>
        {isPricingTab && (
          <Button
            component="label"
            className="uploadedFileName"
            variant="outlined"
            size="medium"
            startIcon={<SaveIcon />}
            onClick={(e) => handleProductUpdate(e)}
          >
            {Constants.SAVE}
          </Button>
        )}
        {!isPricingTab && (
          <>
            <Button
              component="label"
              className="uploadedFileName"
              variant="outlined"
              size="medium"
              startIcon={<FileDownloadOutlinedIcon />}
              onClick={(e) => handleDownloadTemplate(e, data, headers)}
            >
              {Constants.DOWNLOADTEMPLATE}
            </Button>
            <Button
              component="label"
              className="uploadbutton"
              variant="outlined"
              size="medium"
              startIcon={<FileUploadOutlinedIcon />}
            >
              {Constants.PARTIALUPLOAD}
              <VisuallyHiddenInput
                type="file"
                onChange={(e) => handleUpload(e, ButtonType.PARTIALUPLOAD,headers)}
              />
            </Button>
            <Button
              component="label"
              className="uploadbutton"
              variant="outlined"
              size="medium"
              startIcon={<FileUploadOutlinedIcon />}
            >
              {Constants.BULKUPLOAD}
              <VisuallyHiddenInput
                type="file"
                onChange={(e) => handleUpload(e, ButtonType.BULKUPLOAD,headers)}
              />
            </Button>
          </>
        )}
      </div>
    </>
  );
};

export default SearchBoxSection;
